import React from "react";
import {Bookmark, DownloadCloud, Edit, Search, Star} from "react-feather";
import img_editais from "../../imagens/mob_editais.png";
import {CollCard, CollImg, ContainerBody, Wrapper} from "../styleMobile";
import {CardFeatures} from "../Components/CardFeatures";
import {CardHearder} from "../Components/CardHearde";

export const Editais = ({id}) => {
    return (
        <ContainerBody id={id} background={'#5C999F'}>
            <Wrapper>
                <CardHearder
                icon={<Bookmark size={'40px'}/>}
                titulo={'PROSPECÇÃO'}
                texto={'Receba diariamente novas oportunidades pré-qualificadas, ' +
                'baixe os editais sem precisar digitar CAPTCHA, qualifique os editais ' +
                'de seu interesse utilizando nosso modo de visualização EXCLUSIVO para ' +
                'prospecção, defina prioridade, atribua para um responsável e/ou empresa e pronto!'}
                />

                <CollImg>
                    <div>
                        <img
                            src={img_editais}
                            height={"auto"}
                            width={"95%"}
                            alt={"logo wavecode"}
                        />
                    </div>
                </CollImg>

                <CollCard>
                    <CardFeatures icon={<Edit/>} texto={"OPORTUNIDADES\nDO DIA"}/>
                    <CardFeatures icon={<Search/>} texto={"PESQUISA \n" + "AVANÇADA"}/>
                    <CardFeatures icon={<DownloadCloud/>} texto={"DOWNLOAD \n" + "DIRETO"}/>
                    <CardFeatures icon={<Star/>} texto={"TELA DE \n" + "PROSPECÇÃO"}/>
                </CollCard>

            </Wrapper>
        </ContainerBody>
    )
};
